import { Blocker } from '@neo.tax/shared';

export const MaintenanceMode = (): React.ReactElement => (
  <Blocker
    title="We're currently under maintenance"
    description="We apologize for the inconvenience, but we're performing some maintenance at the moment. We'll be back up and running as soon as possible. Thank you for your patience."
  />
);
